import "./styles.css";
import "./App.css";
import React from "react";
import { AuthProvider } from "./auth/AuthProvider";
import { ThemeProvider } from "@mui/material";

import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import CustomTheme from "./CustomTheme";
import Login from "./pages/Login/Login";

const persistor = persistStore(store);

const App = () => {
  return (
    <ThemeProvider theme={CustomTheme}>
      <AuthProvider>
        <Router>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Login />
            </PersistGate>
          </Provider>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
